import { useState, useRef } from "react";
import { API_URL, getValFromLS } from "../../helpers";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

const Form = ({ registrationId, event, success, groups, data }) => {
  const [msg, setMsg] = useState({});

  const formElement = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg({
      type: "working",
      text: "",
    });

    const url = new URL(`${API_URL}/admin/venues2`);
    let formData = new FormData(formElement.current);
    formData.append("registrationId", registrationId);
    formData.append("event", event);
    formData.append("token", getValFromLS("vtoUserToken"));

    try {
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        setMsg({});
        success(json.text);
      } else {
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <form
      ref={formElement}
      method="post"
      action="/"
      onSubmit={(e) => handleSubmit(e)}
      style={{ marginTop: event === "sporting" ? "35px" : "0" }}
    >
      <table className="approved assigned">
        <thead>
          <tr>
            <th colSpan="3" className="hdg">
              {event === "sporting"
                ? "Assign Venues to Sporting Clays Squads"
                : "Assign Courses to Golf Groups"}
            </th>
          </tr>
          <tr>
            <td className="center" style={{ width: "10%" }}>
              Group
            </td>
            <td className="center" style={{ width: "50%" }}>
              {event === "sporting" ? "Sporting Clay Squad" : "Golf Foursome"}
            </td>
            <td className="center" style={{ width: "40%" }}>
              {event === "sporting" ? "Venue" : "Course"}
            </td>
          </tr>
        </thead>

        <tbody>
          {groups.map((group) => {
            return (
              <tr key={group.number}>
                <td className="center">{group.number}</td>
                <td className="center">{group.foursome}</td>
                <td
                  className="center"
                  style={{
                    paddingTop: "10px",
                    paddingBottom: "10px",
                  }}
                >
                  <select
                    name={`group[${group.number}]`}
                    className="form-control"
                    placeholder=""
                    autoComplete="off"
                    style={{
                      display: "inline-block",
                      paddingLeft: "5px",
                      width: "250px",
                    }}
                    defaultValue={group.courseId}
                  >
                    {data.map((item) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="msg-submit">
        {msg.type && <Msg data={msg} />}

        <div
          className={
            msg.type === "working" || msg.type === "success"
              ? "hidden"
              : "submit-container"
          }
        >
          <Submit
            submit={
              event === "sporting"
                ? "Update Venue Assignments"
                : "Update Course Assignments"
            }
          />
        </div>
      </div>
    </form>
  );
};

export default Form;
